import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * ImagePlaceholder Extension for TipTap
 * Renders a loading indicator inline while an image is being uploaded.
 * After upload completes, the placeholder node is replaced with the real image
 * or removed on failure.
 */
import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
const ImagePlaceholderComponent = () => {
    return (_jsx(NodeViewWrapper, { className: "inline-block", as: "span", children: _jsxs("div", { className: "inline-flex items-center gap-2 px-3 py-2 my-1 rounded-md bg-muted/50 border border-border text-muted-foreground text-sm", children: [_jsxs("svg", { className: "h-4 w-4 animate-spin", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", children: [_jsx("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }), _jsx("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })] }), _jsx("span", { children: "Uploading image..." })] }) }));
};
export const ImagePlaceholder = Node.create({
    name: 'imagePlaceholder',
    group: 'inline',
    inline: true,
    atom: true,
    addAttributes() {
        return {
            uploadId: {
                default: null,
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'span[data-image-placeholder]',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['span', { ...HTMLAttributes, 'data-image-placeholder': '' }];
    },
    addNodeView() {
        return ReactNodeViewRenderer(ImagePlaceholderComponent);
    },
});
export default ImagePlaceholder;
//# sourceMappingURL=ImagePlaceholder.js.map